import React, {Fragment} from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import {
    BLANK_REGEX,
    BLANK_REGEX_NEW,
    BLANK_REGEX_WRAPPED,
    BLANK_REGEX_WRAPPED_NEW,
    BUTTON, CLOSE_MODAL
} from "../../utils/constants";
import YuJaButton from "../standardization/YuJaButton";
import FocusTrap from "../FocusTrap";

export default function YuJaFITBPreviewModal({config, queTitle, show, setModalShow, sumbitButtonShow=true, hasBlankRestriction=false}) {
    const blankRegexWrapper = hasBlankRestriction ? BLANK_REGEX_WRAPPED_NEW : BLANK_REGEX_WRAPPED;
    const blankRegex = hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX;

    return (
        <FocusTrap isOpened={show} setIsOpened={setModalShow}>
            <Modal
                id="warning-modal"
                show={show}
                onHide={config.close}
                aria-labelledby="contained-modal-title-vcenter"
                backdrop={true}
                dialogClassName="question-modal2"
            >
                <ModalClose tabIndex={0} role={BUTTON} aria-label={CLOSE_MODAL} onClick={config.close} className="modal-close" />
                <Modal.Header
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Modal.Title as="h2" className="modal-title" id="contained-modal-title-vcenter">
                        {config.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="preview-form-subtext">
                        {
                           queTitle.split(blankRegexWrapper).map((str, i) => { // /(\(.*?\))/g
                            // let re = new RegExp(/\([^\(\)]+\)/g);
                            if (!blankRegex.test(str)) {
                                const oneLine = str.replace(/[\r\n]/g, " @newLine ");
                                const wordArr = oneLine.split(" ");
                                return (
                                    <Fragment key={i}>
                                        {wordArr.map((s, idx) => (<>
                                            {s === '@newLine' &&
                                                <div key={idx} style={{width: "100%"}}></div>
                                            }
                                            {!!s && s !== '@newLine' &&
                                                <div key={idx}>{s}</div>
                                            }
                                        </>))}
                                    </Fragment>
                                );
                            } else {
                                return (
                                    <div
                                        key={i}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            minWidth: 80,
                                            height: 35,
                                            border: "1px solid #D0D0D0",
                                            borderRadius: 3,
                                            padding: 5,
                                            color: "#8C8C8C",
                                            fontWeight: 400,
                                        }}
                                    >

                                        {str.substring(1, str.length - 1)}
                                    </div>
                                );
                            }})
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <YuJaButton type={"secondary"} onClick={config.close}  style={{height: 36}}>
                        {config.cancelText}
                    </YuJaButton>
                    { sumbitButtonShow &&
                    <YuJaButton

                        onClick={(e) => {
                            e.preventDefault();
                            config.submit();
                        }}
                    >
                        {config.okText}
                    </YuJaButton>
                    }
                </Modal.Footer>
            </Modal>
        </FocusTrap>
    );
}